<template>
  <div class="as-skeleton as-form-skeleton">
    <div repeat.for="x of 10" css="width: ${getRandomWidth()}%"></div>
  </div>
</template>
